import 'core-js/modules/es.array.concat.js';
import 'core-js/modules/es.object.to-string.js';
import 'core-js/modules/es.regexp.to-string.js';

var idCounters = {};
function generateSalt() {
  // eslint-disable-next-line @typescript-eslint/no-magic-numbers
  return (Date.now() * Math.random()).toString(36).substring(0, 4);
}
var salt = generateSalt();
function getUID(name) {
  if (!name) {
    throw Error('Argument "name" is required in getUID()');
  }
  if (!idCounters[name]) {
    idCounters[name] = 0;
  }
  var id = String(idCounters[name]++);
  return "".concat(name).concat(id, "-").concat(salt);
}

export { getUID as default };
